import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-reload"
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 30000 }
  }

  connect() {
    this.startReloading()
  }

  disconnect() {
    this.stopReloading()
  }

  startReloading() {
    this.reloadTimeout = setTimeout(() => {
      location.reload()
    }, this.intervalValue)
  }

  stopReloading() {
    if (this.reloadTimeout) {
      clearTimeout(this.reloadTimeout)
    }
  }
}